import React, { useState, useEffect } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  Image,
  useColorScheme,
  Dimensions,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { LineChart, BarChart, PieChart } from 'react-native-chart-kit';

const screenWidth = Dimensions.get('window').width;

const FriendComparisonScreen = ({ route, navigation }) => {
  const { friendId } = route.params;
  const isDarkMode = useColorScheme() === 'dark';
  const [activeTab, setActiveTab] = useState('nutrition');
  const [selectedPeriod, setSelectedPeriod] = useState('week');
  
  // 从模拟数据中获取好友信息
  const friend = mockFriends.find(f => f.id === friendId) || mockFriends[0];
  const currentUser = mockCurrentUser;

  return (
    <ScrollView 
      style={{ 
        flex: 1,
        backgroundColor: isDarkMode ? '#1f2937' : '#f9fafb',
      }}
      contentContainerStyle={{ padding: 16 }}
    >
      {/* 用户对比卡片 */}
      <View style={{ 
        backgroundColor: isDarkMode ? '#374151' : 'white',
        borderRadius: 16,
        padding: 16,
        marginBottom: 20,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
      }}>
        <Text style={{ 
          fontSize: 18,
          fontWeight: 'bold',
          color: isDarkMode ? 'white' : '#1f2937',
          marginBottom: 16,
        }}>
          数据对比
        </Text>
        
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          {/* 当前用户信息 */}
          <View style={{ alignItems: 'center', width: '45%' }}>
            <Image 
              source={{ uri: currentUser.avatar }} 
              style={{ 
                width: 70, 
                height: 70, 
                borderRadius: 35,
                marginBottom: 8,
                borderWidth: 3,
                borderColor: '#2563eb',
              }} 
            />
            <Text style={{ 
              fontSize: 16,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {currentUser.name}
            </Text>
            <View style={{ 
              flexDirection: 'row',
              alignItems: 'center',
              backgroundColor: getHealthScoreColor(currentUser.healthScore),
              paddingHorizontal: 8,
              paddingVertical: 4,
              borderRadius: 12,
              marginBottom: 8,
            }}>
              <Ionicons name="pulse" size={14} color="white" style={{ marginRight: 4 }} />
              <Text style={{ color: 'white', fontWeight: 'bold' }}>
                {currentUser.healthScore}分
              </Text>
            </View>
          </View>
          
          {/* VS标志 */}
          <View style={{ 
            justifyContent: 'center', 
            alignItems: 'center',
            width: '10%',
          }}>
            <Text style={{ 
              fontSize: 18, 
              fontWeight: 'bold',
              color: isDarkMode ? '#d1d5db' : '#6b7280',
            }}>
              VS
            </Text>
          </View>
          
          {/* 好友信息 */}
          <View style={{ alignItems: 'center', width: '45%' }}>
            <Image 
              source={{ uri: friend.avatar }} 
              style={{ 
                width: 70, 
                height: 70, 
                borderRadius: 35,
                marginBottom: 8,
                borderWidth: 3,
                borderColor: '#0d9488',
              }} 
            />
            <Text style={{ 
              fontSize: 16,
              fontWeight: 'bold',
              color: isDarkMode ? 'white' : '#1f2937',
              marginBottom: 4,
            }}>
              {friend.name}
            </Text>
            <View style={{ 
              flexDirection: 'row',
              alignItems: 'center',
              backgroundColor: getHealthScoreColor(friend.healthScore),
              paddingHorizontal: 8,
              paddingVertical: 4,
              borderRadius: 12,
              marginBottom: 8,
            }}>
              <Ionicons name="pulse" size={14} color="white" style={{ marginRight: 4 }} />
              <Text style={{ color: 'white', fontWeight: 'bold' }}>
                {friend.healthScore}分
              </Text>
            </View>
          </View>
        </View>
        
        {/* 简要统计对比 */}
        <View style={{ 
          flexDirection: 'row', 
          justifyContent: 'space-between',
          marginTop: 16,
          paddingTop: 16,
          borderTopWidth: 1,
          borderTopColor: isDarkMode ? '#4b5563' : '#f3f4f6',
        }}>
          <StatisticItem 
            label="连续打卡"
            valueLeft={`${currentUser.stats.streak}天`}
            valueRight={`${friend.stats.streak}天`}
            iconName="flame"
            iconColor="#f59e0b"
            isDarkMode={isDarkMode}
          />
          <StatisticItem 
            label="目标完成"
            valueLeft={`${currentUser.stats.goalsCompleted}个`}
            valueRight={`${friend.stats.goalsCompleted}个`}
            iconName="trophy"
            iconColor="#10b981"
            isDarkMode={isDarkMode}
          />
          <StatisticItem 
            label="饮食相似度"
            valueLeft=""
            valueRight={`${friend.stats.similarities}%`}
            iconName="nutrition"
            iconColor="#8b5cf6"
            isDarkMode={isDarkMode}
            isSingle={true}
          />
        </View>
      </View>
      
      {/* 数据分析标签栏 */}
      <View style={{ 
        flexDirection: 'row',
        backgroundColor: isDarkMode ? '#374151' : 'white',
        borderRadius: 12,
        marginBottom: 16,
        padding: 4,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.1,
        shadowRadius: 2,
        elevation: 2,
      }}>
        <TouchableOpacity 
          style={{ 
            flex: 1,
            paddingVertical: 10,
            alignItems: 'center',
            borderRadius: 10,
            backgroundColor: activeTab === 'nutrition' 
              ? (isDarkMode ? '#4b5563' : '#e0f2fe') 
              : 'transparent',
          }}
          onPress={() => setActiveTab('nutrition')}
        >
          <Text style={{ 
            color: activeTab === 'nutrition' ? '#2563eb' : (isDarkMode ? '#d1d5db' : '#6b7280'),
            fontWeight: activeTab === 'nutrition' ? 'bold' : 'normal',
          }}>
            营养摄入
          </Text>
        </TouchableOpacity>
        
        <TouchableOpacity 
          style={{ 
            flex: 1,
            paddingVertical: 10,
            alignItems: 'center',
            borderRadius: 10,
            backgroundColor: activeTab === 'exercise' 
              ? (isDarkMode ? '#4b5563' : '#e0f2fe') 
              : 'transparent',
          }}
          onPress={() => setActiveTab('exercise')}
        >
          <Text style={{ 
            color: activeTab === 'exercise' ? '#2563eb' : (isDarkMode ? '#d1d5db' : '#6b7280'),
            fontWeight: activeTab === 'exercise' ? 'bold' : 'normal',
          }}>
            运动记录
          </Text>
        </TouchableOpacity>
        
        <TouchableOpacity 
          style={{ 
            flex: 1,
            paddingVertical: 10,
            alignItems: 'center',
            borderRadius: 10,
            backgroundColor: activeTab === 'water' 
              ? (isDarkMode ? '#4b5563' : '#e0f2fe') 
              : 'transparent',
          }}
          onPress={() => setActiveTab('water')}
        >
          <Text style={{ 
            color: activeTab === 'water' ? '#2563eb' : (isDarkMode ? '#d1d5db' : '#6b7280'),
            fontWeight: activeTab === 'water' ? 'bold' : 'normal',
          }}>
            饮水记录
          </Text>
        </TouchableOpacity>
        
        <TouchableOpacity 
          style={{ 
            flex: 1,
            paddingVertical: 10,
            alignItems: 'center',
            borderRadius: 10,
            backgroundColor: activeTab === 'sleep' 
              ? (isDarkMode ? '#4b5563' : '#e0f2fe') 
              : 'transparent',
          }}
          onPress={() => setActiveTab('sleep')}
        >
          <Text style={{ 
            color: activeTab === 'sleep' ? '#2563eb' : (isDarkMode ? '#d1d5db' : '#6b7280'),
            fontWeight: activeTab === 'sleep' ? 'bold' : 'normal',
          }}>
            睡眠数据
          </Text>
        </TouchableOpacity>
      </View>
      
      {/* 时间周期选择器 */}
      <View style={{ 
        flexDirection: 'row', 
        justifyContent: 'center',
        marginBottom: 20,
      }}>
        <TouchableOpacity 
          style={{ 
            paddingHorizontal: 16,
            paddingVertical: 6,
            backgroundColor: selectedPeriod === 'week' 
              ? (isDarkMode ? '#4b5563' : '#e0f2fe') 
              : 'transparent',
            borderRadius: 20,
            marginRight: 12,
            borderWidth: selectedPeriod === 'week' ? 0 : 1,
            borderColor: isDarkMode ? '#4b5563' : '#e5e7eb',
          }}
          onPress={() => setSelectedPeriod('week')}
        >
          <Text style={{ 
            color: selectedPeriod === 'week' 
              ? '#2563eb' 
              : (isDarkMode ? '#d1d5db' : '#6b7280'),
            fontWeight: selectedPeriod === 'week' ? 'bold' : 'normal',
          }}>
            本周
          </Text>
        </TouchableOpacity>
        
        <TouchableOpacity 
          style={{ 
            paddingHorizontal: 16,
            paddingVertical: 6,
            backgroundColor: selectedPeriod === 'month' 
              ? (isDarkMode ? '#4b5563' : '#e0f2fe') 
              : 'transparent',
            borderRadius: 20,
            borderWidth: selectedPeriod === 'month' ? 0 : 1,
            borderColor: isDarkMode ? '#4b5563' : '#e5e7eb',
          }}
          onPress={() => setSelectedPeriod('month')}
        >
          <Text style={{ 
            color: selectedPeriod === 'month' 
              ? '#2563eb' 
              : (isDarkMode ? '#d1d5db' : '#6b7280'),
            fontWeight: selectedPeriod === 'month' ? 'bold' : 'normal',
          }}>
            本月
          </Text>
        </TouchableOpacity>
      </View>

      {/* 图表区域将在下一步添加 */}
    </ScrollView>
  );
};

// 统计项组件
const StatisticItem = ({ label, valueLeft, valueRight, iconName, iconColor, isDarkMode, isSingle = false }) => {
  return (
    <View style={{ alignItems: 'center' }}>
      <View style={{ 
        flexDirection: 'row', 
        alignItems: 'center',
        marginBottom: 6,
      }}>
        <Ionicons name={iconName} size={16} color={iconColor} style={{ marginRight: 4 }} />
        <Text style={{ 
          fontSize: 14,
          color: isDarkMode ? '#d1d5db' : '#6b7280',
        }}>
          {label}
        </Text>
      </View>
      
      {isSingle ? (
        <Text style={{ 
          fontSize: 16,
          fontWeight: 'bold',
          color: isDarkMode ? 'white' : '#1f2937',
        }}>
          {valueRight}
        </Text>
      ) : (
        <View style={{ flexDirection: 'row' }}>
          <Text style={{ 
            fontSize: 16,
            fontWeight: 'bold',
            color: '#2563eb',
            marginRight: 8,
          }}>
            {valueLeft}
          </Text>
          <Text style={{ fontSize: 16, color: isDarkMode ? '#d1d5db' : '#6b7280' }}>vs</Text>
          <Text style={{ 
            fontSize: 16,
            fontWeight: 'bold',
            color: '#0d9488',
            marginLeft: 8,
          }}>
            {valueRight}
          </Text>
        </View>
      )}
    </View>
  );
};

// 获取健康分数对应的颜色
const getHealthScoreColor = (score) => {
  if (score >= 90) return '#10b981'; // 绿色
  if (score >= 80) return '#2563eb'; // 蓝色
  if (score >= 70) return '#f59e0b'; // 橙色
  return '#ef4444'; // 红色
};

// 模拟数据 - 当前用户
const mockCurrentUser = {
  id: 'current',
  name: '我',
  avatar: 'https://randomuser.me/api/portraits/men/11.jpg',
  healthScore: 88,
  stats: {
    streak: 14,
    goalsCompleted: 2,
  },
  nutritionData: {
    week: {
      protein: [65, 72, 68, 70, 75, 62, 80],
      carbs: [220, 210, 228, 215, 235, 225, 218],
      fat: [58, 62, 55, 60, 65, 55, 70],
      calories: [1650, 1720, 1680, 1700, 1750, 1620, 1800],
    },
    month: {
      protein: [68, 70, 67, 72],
      carbs: [215, 220, 210, 225],
      fat: [60, 58, 62, 65],
      calories: [1680, 1700, 1650, 1750],
    },
  },
  exerciseData: {
    week: {
      steps: [8500, 7800, 9200, 8000, 8600, 9500, 7500],
      duration: [45, 30, 60, 40, 50, 65, 35],
      calories: [320, 240, 450, 300, 380, 480, 260],
    },
    month: {
      steps: [8200, 8500, 8000, 8800],
      duration: [45, 48, 42, 52],
      calories: [330, 350, 320, 400],
    },
  },
  waterData: {
    week: [1800, 2000, 1700, 2200, 1900, 2100, 2000],
    month: [1900, 2000, 1850, 2100],
  },
  sleepData: {
    week: [7.2, 6.8, 7.5, 7.0, 7.8, 6.5, 7.6],
    month: [7.1, 7.3, 7.0, 7.5],
  },
  nutrientDistribution: {
    protein: 25,
    carbs: 50,
    fat: 25,
  },
};

// 模拟数据 - 好友列表
const mockFriends = [
  {
    id: 'f1',
    name: '张健康',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    healthScore: 92,
    stats: {
      streak: 18,
      goalsCompleted: 3,
      similarities: 85,
    },
    nutritionData: {
      week: {
        protein: [75, 78, 72, 80, 75, 82, 85],
        carbs: [200, 210, 190, 205, 195, 215, 208],
        fat: [50, 48, 52, 45, 55, 50, 48],
        calories: [1550, 1600, 1520, 1580, 1600, 1620, 1650],
      },
      month: {
        protein: [75, 78, 80, 82],
        carbs: [200, 205, 210, 215],
        fat: [50, 48, 45, 48],
        calories: [1580, 1600, 1620, 1650],
      },
    },
    exerciseData: {
      week: {
        steps: [10500, 11800, 10200, 11000, 10600, 12500, 11500],
        duration: [65, 70, 60, 75, 70, 85, 80],
        calories: [450, 480, 420, 500, 460, 520, 490],
      },
      month: {
        steps: [11000, 10800, 11500, 12000],
        duration: [70, 68, 75, 80],
        calories: [470, 460, 490, 510],
      },
    },
    waterData: {
      week: [2300, 2200, 2400, 2100, 2500, 2300, 2400],
      month: [2300, 2250, 2400, 2350],
    },
    sleepData: {
      week: [7.8, 8.0, 7.5, 8.2, 7.6, 8.0, 7.9],
      month: [7.8, 7.9, 8.0, 7.9],
    },
    nutrientDistribution: {
      protein: 35,
      carbs: 45,
      fat: 20,
    },
  },
  {
    id: 'f2',
    name: '李营养',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    healthScore: 87,
    stats: {
      streak: 12,
      goalsCompleted: 2,
      similarities: 72,
    },
    nutritionData: {
      week: {
        protein: [60, 65, 62, 68, 70, 64, 66],
        carbs: [240, 230, 245, 235, 225, 238, 230],
        fat: [62, 58, 64, 60, 56, 59, 61],
        calories: [1750, 1700, 1780, 1720, 1680, 1730, 1710],
      },
      month: {
        protein: [63, 65, 66, 68],
        carbs: [235, 230, 228, 225],
        fat: [60, 58, 59, 56],
        calories: [1730, 1700, 1710, 1680],
      },
    },
    exerciseData: {
      week: {
        steps: [7500, 8200, 7800, 8500, 7600, 8000, 8300],
        duration: [40, 45, 42, 50, 38, 44, 48],
        calories: [280, 310, 290, 350, 270, 300, 330],
      },
      month: {
        steps: [7800, 8000, 8200, 8400],
        duration: [42, 44, 46, 49],
        calories: [290, 300, 310, 340],
      },
    },
    waterData: {
      week: [1900, 2100, 2000, 2200, 1950, 2050, 2150],
      month: [2000, 2050, 2100, 2150],
    },
    sleepData: {
      week: [7.0, 7.2, 6.8, 7.5, 7.3, 7.0, 7.4],
      month: [7.0, 7.2, 7.3, 7.5],
    },
    nutrientDistribution: {
      protein: 22,
      carbs: 55,
      fat: 23,
    },
  },
];

export default FriendComparisonScreen; 